import { useEffect } from 'react'

import { EVENT_NAME_CHANGE } from '../../constants/event'

/**
 * React hook that listens to a media query and triggers a callback
 * whenever the query match state changes.
 *
 * @param {(matches: boolean) => void} callback - Function invoked on match change
 * @param {string} [query] - Media query to evaluate
 *
 * @example
 * useBreakpoint((isMobile) => {
 *   console.log(isMobile)
 * }, '(max-width: 768px)')
 */
export function useBreakpoint(callback, query) {
  useEffect(() => {
    const media = window.matchMedia(query)

    function handler(event) {
      if (event.matches) {
        callback()
      }
    }

    handler(media)

    media.addEventListener(EVENT_NAME_CHANGE, handler)

    return () => {
      media.removeEventListener(EVENT_NAME_CHANGE, handler)
    }
  }, [callback, query])
}
